import moment from 'moment';

function toTimeZone(dateStr: string, timeZone: string) {
  return new Date(dateStr).toLocaleString('en-US', { timeZone: timeZone });
}

export function articleDate(dateStr: string) {
  const inHomeTimeZone = toTimeZone(dateStr, 'America/Los_Angeles');
  return moment(inHomeTimeZone).format('MMM. D, YYYY H:mm A');
}
